import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const PageNotFoundComponent = () => {
  const { t } = useTranslation();
  const [moveNumber, setMoveNumber] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setMoveNumber(false);
    }, 500);
    setTimeout(() => {
      setMoveNumber(true);
    }, 1500);
  }, []);

  return (
    <Styles moveNumber={moveNumber}>
      <div className="container">
        <h1>404</h1>
        <h2>{t("Page Not Found")}</h2>
        <p>{t("Page Not Found Description")}</p>
        <Link to="/">{t("Go to Home")}</Link>
      </div>
    </Styles>
  );
};

export default PageNotFoundComponent;
